import * as React from 'react';
const SvgRobotPlayStep = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 0a1 1 0 011 1v14a1 1 0 11-2 0V1a1 1 0 011-1zm-3.48 7.078c.64.382.64 1.335 0 1.717L1.44 14.802C.8 15.184 0 14.707 0 13.944V1.929c0-.763.8-1.24 1.44-.858l10.08 6.007z"
            fill="currentColor"
        />
    </svg>
);
export default SvgRobotPlayStep;
